// A view's title — a section's "A–A", a reflected ceiling plan's — as the plan
// paints it, shared so both are picked, moved and deleted alike.
import type { Vec2 } from '../shared/types';

/** The selection blue a selected title is painted in. */
const VIEW_TITLE_SELECTED = '#4aa3ff';

/** A view title's box on screen (px), as painted: what a press on it finds. */
export interface TitleBox { x0: number; y0: number; x1: number; y1: number }
/** The font every view's title is painted in (a section's, a ceiling plan's). */
const VIEW_TITLE_FONT = 'bold 13px system-ui, sans-serif';

/** Paint a view's title, top-centred on `at` (screen px) — selected, in the
 *  selection blue inside a dashed box — and return its box. */
export function paintViewTitle(ctx: CanvasRenderingContext2D, at: Vec2, text: string, color: string, selected = false): TitleBox {
  ctx.save();
  ctx.font = VIEW_TITLE_FONT; ctx.textAlign = 'center'; ctx.textBaseline = 'top';
  const w = ctx.measureText(text).width, box = { x0: at.x - w / 2 - 3, y0: at.y - 2, x1: at.x + w / 2 + 3, y1: at.y + 16 };
  ctx.fillStyle = selected ? VIEW_TITLE_SELECTED : color;
  ctx.fillText(text, at.x, at.y);
  if (selected) {
    ctx.strokeStyle = VIEW_TITLE_SELECTED; ctx.lineWidth = 1; ctx.setLineDash([4, 3]);
    ctx.strokeRect(box.x0, box.y0, box.x1 - box.x0, box.y1 - box.y0);
  }
  ctx.restore();
  return box;
}
